import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
`;

export const Title = styled.h2`
	font-size: 16px;
	color: ${tokens.color_gray_dark};
	font-weight: 600;
	line-height: 22px;
	text-align: center;
`;

export const Description = styled.p`
	font-size: 14px;
	color: ${tokens.color_gray_dark};
	font-weight: 500;
	line-height: 22px;
`;

export const ContainerButtons = styled.div`
	margin-top: 24px;
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
